import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import PeopleIcon from "@mui/icons-material/People";
import EmployeePickerField from "../../../../../common/selectComponents/EmployeePicker";

const EmployeeTransactionApproverModal = ({ isOpen, onClose, onSave, loading, selectedData }) => {
  const [selectedEmp, setSelectedEmp] = useState({ id: "", fullName: "" });

  // ADDED: Handle Edit Mode initialization
  useEffect(() => {
    if (isOpen) {
      if (selectedData) {
        setSelectedEmp({
          id: selectedData.employeePersonalInformationId,
          fullName: selectedData.fullName
        });
      } else {
        setSelectedEmp({ id: "", fullName: "" });
      }
    }
  }, [isOpen, selectedData]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (selectedEmp.id) {
      // If editing, we pass the ID of the record, the new employee ID, and names
      if (selectedData) {
        onSave(selectedData.id, selectedEmp.id, selectedEmp.fullName, selectedData.fullName);
      } else {
        onSave(selectedEmp.id, selectedEmp.fullName);
      }
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3" style={{ marginTop: 0 }} >
      <div className="bg-white w-full md:w-[450px] rounded-lg shadow-xl flex flex-col">
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold flex items-center space-x-2">
            <PeopleIcon className="text-blue-500" />
            <span>{selectedData ? "Edit Approver" : "Add Approver"}</span>
          </h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Employee</label>
          <EmployeePickerField
            employeePersonalInformationId={selectedEmp.id}
            displayValue={selectedEmp.fullName}
            onSelect={(emp) => setSelectedEmp({ id: emp.id, fullName: emp.fullName })}
            onClear={() => setSelectedEmp({ id: "", fullName: "" })}
            placeholder="Search employee..."
          />
        </div>

        <div className="flex justify-end space-x-2 p-5 border-t">
          <button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded border-none cursor-pointer">Cancel</button>
          <button
            onClick={handleSave}
            disabled={!selectedEmp.id || loading}
            className={`px-6 py-2 rounded border-none cursor-pointer text-white ${!selectedEmp.id ? 'bg-blue-300' : 'bg-blue-600'}`}
          >
            {loading ? "Processing..." : (selectedData ? "Update" : "Add")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTransactionApproverModal;